import React from "react";
import { motion } from "framer-motion";
import {
  FiGlobe,
  FiBookOpen,
  FiCpu,
  FiUserCheck,
  FiMessageCircle,
  FiUsers,
  FiTarget,
  FiHeart,
  FiAward,
  FiTablet,
  FiCode,
  FiStar,
  FiSmile,
  FiMap,
  FiUserPlus,
  FiActivity,
  FiRepeat,
  FiGift,
  FiShare2,
} from "react-icons/fi";
import RankridgeLanding from "./rankridge_landing";
import Abouty from "./Aboutwhy";
import VisionMissionGrid from "./VisionMissionGrid";

export default function AboutComponent() {
  return (
    <div className=" text-green-900 px-1 py-1 max-w-7xl mx-auto text-black mt-8 ">
      <motion.h1
        className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-6 text-center leading-snug max-w-4xl mx-auto text-black "
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Why Choose Rankridge International Schools ?
      </motion.h1>
   <h6  className="text-xl text-center text-black font-extrabold mb-6">    Rankridge Empowering Today’s Learners &  Leading Tomorrow’s Leaders.
 </h6>
      <motion.p
        className="text-xl mb-12 text-center text-black "
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        The Best International Schools  in Hyderabad  for Global-Ready Education
      </motion.p>
<section className="bg-[#20b2aa]">
  <RankridgeLanding />
</section>
      <VisionMissionGrid />

<section>
    <Abouty />
</section>

      <div className="space-y-14 text-center">
        {/* {sections.map((section, index) => (
          <AnimatedSection
            key={index}
            icon={section.icon}
            title={section.title}
            content={section.content}
          />
        ))} */}
        
        <motion.div
          className="text-center mt-20 w-full"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-black mb-4">
            The Rankridge Advantage
          </h2>
          <p className="text-lg text-black  text-center m-3">
           At Rankridge International School, education is not just about marks it's about meaning. We prepare your child to be a future-ready leader,Learning on your own and building skills to handle challenges in difficult situations, and responsible global citizen.


          </p>
        </motion.div>

        <motion.div
          className="text-center mt-14"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <h2 className="text-2xl font-semibold text-black mb-2">
            📍 Visit Rankridge Today
          </h2>
          <center>
          <p className="mb-4 text-black text-center m-3">
            Looking for the best international school in Kukatpally, Hyderabad?
            Schedule a campus tour, meet our academic advisors, and experience
            the Rankridge difference.
          </p>
          </center>
          {/* <div className="flex flex-wrap justify-center gap-4">
            <button className="bg-green-700 hover:bg-green-800 transition text-white px-6 py-3 rounded-xl shadow-md">
              Call Now
            </button>
            <button className="bg-blue-700 hover:bg-blue-800 transition text-white px-6 py-3 rounded-xl shadow-md">
              Book a Visit
            </button>
            <button className="bg-gray-800 hover:bg-gray-900 transition text-white px-6 py-3 rounded-xl shadow-md">
              Download Brochure
            </button>
          </div> */}
        </motion.div>
      </div>
    </div>
  );
}

function AnimatedSection({ icon, title, content }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-10"
    >
      <div className="text-green-700 w-24 h-24 flex items-center justify-center text-[100px]">
        {icon}
      </div>
      <div className="text-center md:text-left max-w-4xl">
        <h3 className="text-2xl font-semibold text-green-800 mb-2">{title}</h3>
        {/* <p className="text-lg text-gray-700 leading-relaxed">{content}</p> */}
      </div>
    </motion.div>
  );
}
 const sections = [
  {
    icon: <FiGlobe />,
    title: "Global Curriculum for a Global Future",
    content:
      "Rankridge offers internationally recognized curricula such as IGCSE, Cambridge, and IB programs, giving students a competitive edge.",
  },
  {
    icon: <FiBookOpen />,
    title: "High-Quality Education Standards",
    content:
      "Our curriculum emphasizes conceptual understanding, inquiry-based learning, and practical application.",
  },
  {
    icon: <FiCpu />,
    title: "Focus on Innovation & Critical Thinking",
    content:
      "Rankridge cultivates innovation through design thinking, research projects, and experiential learning.",
  },
  {
    icon: <FiUserCheck />,
    title: "Personalized Learning for Every Child",
    content:
      "With small class sizes and attentive faculty, Rankridge provides personalized support that helps each student progress at their own pace.",
  },
  {
    icon: <FiMessageCircle />,
    title: "Language Fluency and Communication Skills",
    content:
      "Students learn in an English-medium environment with additional language options, enabling fluency and multilingual communication skills.",
  },
  {
    icon: <FiUsers />,
    title: "World-Class Teachers",
    content:
      "Our educators bring global teaching experience and incorporate best practices that make learning engaging, inclusive, and impactful.",
  },
  {
    icon: <FiTarget />,
    title: "University and Career-Readiness",
    content:
      "Through career counseling and academic preparation, students gain admission to top global universities with strong portfolios and life skills.",
  },
  {
    icon: <FiHeart />,
    title: "Cultural Diversity and Inclusion",
    content:
      "Our diverse student community fosters cultural exchange and respect for all backgrounds, building global citizens with empathy.",
  },
  {
    icon: <FiAward />,
    title: "Holistic Education with Co-curricular Excellence",
    content:
      "Beyond academics, we focus on sports, arts, leadership, coding, robotics, and more—ensuring balanced, all-round development.",
  },
  {
    icon: <FiTablet />,
    title: "Advanced Digital Learning",
    content:
      "Equipped with smart classrooms and e-learning platforms, Rankridge integrates technology seamlessly into daily education.",
  },
  {
    icon: <FiCode />,
    title: "Strong STEM and 21st-Century Skills",
    content:
      "We prepare students for modern careers with hands-on STEM activities, coding, and future-ready digital competencies.",
  },
  {
    icon: <FiStar />,
    title: "Values, Life Skills & Global Citizenship",
    content:
      "We develop character and conscience through life skills training, community work, and ethical education.",
  },
  {
    icon: <FiSmile />,
    title: "Focus on Mental Health and Well-being",
    content:
      "Mindfulness sessions, counseling support, and a nurturing environment help ensure emotional well-being and resilience.",
  },
  {
    icon: <FiMap />,
    title: "International Exposure & Study Tours",
    content:
      "Our students gain international exposure through exchange programs, global collaborations, and educational tours.",
  },
  {
    icon: <FiUserPlus />,
    title: "Strong Parent Involvement",
    content:
      "We promote open communication with regular updates, meetings, and involvement in school events.",
  },
  {
    icon: <FiActivity />,
    title: "MUNs & Competitions",
    content:
      "Participation in national and international contests builds leadership, teamwork, and public speaking skills.",
  },
  {
    icon: <FiRepeat />,
    title: "Ideal for Expats & Frequent Movers",
    content:
      "With a globally consistent curriculum, Rankridge suits families who relocate across regions or countries.",
  },
  {
    icon: <FiGift />,
    title: "Flexible Admission & Transparent Evaluation",
    content:
      "We offer rolling admissions, flexible entry points, and continuous assessments for clarity and comfort.",
  },
  {
    icon: <FiShare2 />,
    title: "Enrichment Beyond the Classroom",
    content:
      "Clubs like robotics, debating, and environmental activities offer platforms for students to pursue passions and develop confidence.",
  },
  {
    icon: <FiUsers />,
    title: "Strong Alumni Network",
    content:
      "Our alumni remain connected, offering mentorship, networking, and career support across the globe.",
  },
];